module.exports = __webpack_public_path__ + "img/icon-clock-white.c2bb11ed.svg";